import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './EmptyText.module.scss';
import clsx from 'clsx';
const EmptyText = ({ children, className, height = '80', fontSize = 20 }) => {
  return (
    <>
      <div className={clsx(styles.wrap)} style={{ height: `${height}px`, fontSize: `${fontSize}px` }}>
        {children}
      </div>
    </>
  );
};

export default EmptyText;
